import { useQuery } from 'react-query';
import { useService } from 'shared/providers';

export function useQueryProjectTypes() {
  const { quoteService } = useService();
  const { data, isLoading, isFetching } = useQuery<string[], Error>(['quote-project-types'], () =>
    quoteService.getQuoteProjectTypes()
  );

  return { projectTypes: data ?? [], isLoading, isFetching } as const;
}
